import React from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "../../../context/ThemeContext";
import CoordinatorSidebar from "./CoordinatorSidebar";

const CoordinatorLayout: React.FC = () => {
  return (
   <ThemeProvider>
  <div className="admin-wrapper d-flex" style={{ marginTop: "70px" }}>

    {/* Fixed Sidebar */}
    <div
      style={{
        width: "250px",
        position: "fixed",
        top: "70px",
        left: 0,
        bottom: 0,
        background: "#fff",
        borderRight: "1px solid #eee",
        zIndex: 1000
      }}
    >
      <CoordinatorSidebar />
    </div>

    {/* Main Content */}
    <div
      className="admin-main flex-grow-1"
      style={{
        marginLeft: "250px",
        height: "calc(100vh - 70px)",
      }}
    >
      <div className="admin-content p-4">
        <Outlet />
      </div>
    </div>

  </div>
</ThemeProvider>
  );
};

export default CoordinatorLayout;